import { createEntitySchemas } from '../../../utils/normalize'

export const DOCUMENT_INFO = 'documentsInfo'
export const documentsInfoSchemas = createEntitySchemas(DOCUMENT_INFO)
